export default "__VITE_ASSET__cMY4ELj___"